import * as angular from 'angular';

import { IdentifierType, ComponentDefinition } from '../../../models';

class IdentifierIconController implements angular.IComponentController {

    identifierType;

    static $inject = [];


    $onInit() {
        this.identifierType = IdentifierType;
    }
}

export const wtIdentifierIcon: ComponentDefinition = {
    componentId: 'wtIdentifierIcon',
    controller: IdentifierIconController,
    template: require('./identifierIcon.component.html'),
    controllerAs: 'vm',
    bindings: {
        type: '<',
        large: '<?'
    }
};
